export const printPage = (printId, title) => {
  const target = document.getElementById(printId);
  if (!target) {
    return;
  }
  const styles = document.createElement('style');
  styles.type = 'text/css';
  const addedStyles = '.no-print { display: none }';
  styles.appendChild(document.createTextNode(addedStyles));
  let frame;
  let iframe;
  if (target.nodeName.toLowerCase() === 'iframe') {
    frame = target.contentWindow || target.contentDocument;
  } else {
    iframe = document.createElement('iframe');
    iframe.name = 'tempFrame';
    iframe.style.position = 'absolute';
    iframe.style.top = '-1000000px';
    document.body.appendChild(iframe);
    let frameDoc;
    if (iframe.contentWindow) {
      frameDoc = iframe.contentWindow;
    } else if (iframe.contentDocument.document) {
      frameDoc = iframe.contentDocument.document;
    } else {
      frameDoc = iframe.contentDocument;
    }
    frameDoc.document.open();
    if (title) {
      frameDoc.document.write(`<html><head><title>${title}</title>`);
      frameDoc.document.write(
        '</head><body style="font-family: Arial, Helvetica, sans; font-size: 14px; line-height: 20px">'
      );
      frameDoc.document.write(`<h1>${title}</h1>`);
    } else {
      frameDoc.document.write('<html><head>');
      frameDoc.document.write(
        '</head><body style="font-family: Arial, Helvetica, sans; font-size: 14px; line-height: 20px">'
      );
    }
    frameDoc.document.write(target.innerHTML);
    frameDoc.document.write('</body></html>');
    frameDoc.document.head.appendChild(styles);
    frameDoc.document.close();
  }

  const url = target.src;
  if (window.AppConfig.isMobile && !url) {
    const tab = window.open(``, '_blank');
    if (title) {
      tab.document.write(`<html><head><title>${title}</title>`);
      tab.document.write(
        '</head><body style="font-family: Arial, Helvetica, sans; font-size: 14px; line-height: 20px">'
      );
      tab.document.write(`<h1>${title}</h1>`);
    } else {
      tab.document.write('<html><head>');
      tab.document.write(
        '</head><body style="font-family: Arial, Helvetica, sans; font-size: 14px; line-height: 20px">'
      );
    }
    tab.document.write(target.innerHTML);
    tab.document.write('</body></html>');
    tab.document.head.appendChild(styles);
    tab.document.close();
    $('tab.document').ready(() => {
      setTimeout(() => {
        tab.focus();
        tab.print();
      }, 500);
    });
  } else if (window.AppConfig.isMobile && url) {
    const tab = window.open(`${url}&print=true`, '_blank');
    tab.focus();
    setTimeout(() => tab.print(), 500);
  } else if (frame) {
    frame.print();
  } else {
    setTimeout(() => {
      window.frames.tempFrame.focus();
      window.frames.tempFrame.print();
    }, 500);

    setTimeout(() => {
      document.body.removeChild(iframe);
    }, 1000);
  }
};
